import { SummaryFeatureList } from '~app/pages/Pricing/transformers/summary/types';
import FormsFeatureList from './formsFeatureList';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const AdvantageFeatureList: SummaryFeatureList = ['grow_2792_text_analysis', 'quizzes_pro', 'grow_2792_multilingual'];

export default [...FormsFeatureList, ...AdvantageFeatureList];
